/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { t } from "i18n";
import { get } from "lodash";
import TextField from "components/text-field/text-field";
import { BrightcoveConfig, Integrations } from "api/integrations";
import { isClientValidationError } from "utils/validation.utils";

interface Props {
  integration: { key: Integrations.Brightcove; value: BrightcoveConfig };
  updateIntegrationField: (key: string, value: Object) => void;
  readOnly?: boolean;
  errors: Error | null;
}

const Brightcove: React.SFC<Props> = ({ integration, updateIntegrationField, readOnly, errors }) => {
  const integrationName = integration.key;

  return (
    <React.Fragment>
      <TextField
        label={t("integrations.fields.client-id")}
        value={integration.value["client-id"]}
        onChange={(value) => updateIntegrationField(integrationName, { "client-id": value })}
        readOnly={readOnly}
        errorMessage={
          isClientValidationError<BrightcoveConfig>(errors)
            ? get(errors, ["errors", "value", "client-id", "0"])
            : undefined
        }
      />
      <TextField
        label={t("integrations.fields.client-secret")}
        value={integration.value["client-secret"]}
        onChange={(value) => updateIntegrationField(integrationName, { "client-secret": value })}
        readOnly={readOnly}
        errorMessage={
          isClientValidationError<BrightcoveConfig>(errors)
            ? get(errors, ["errors", "value", "client-secret", "0"])
            : undefined
        }
      />
    </React.Fragment>
  );
};

export default Brightcove;
